const collationComponents = {
  en: {
    resultsComponents: {
      candidateResults: "Candidate Results",
      noCandidates: "No candidates data available",
      resultsByParty: "Results by Party",
      resultsByRegion: "Results by Region",
      region: "Region",
      stations: "Stations",
      votesCast: "Votes Cast",
      turnout: "Turnout",
      leadingParty: "Leading Party",
      status: {
        verified: "verified", approved: "approved", certified: "certified",
        pending: "pending", submitted: "submitted", disputed: "disputed",
        rejected: "rejected", correction_requested: "correction requested"
      }
    },
    statCards: {
      pollingStations: "Polling Stations",
      votesCast: "Votes Cast",
      validVotes: "Valid Votes",
      rejectedVotes: "Rejected Votes",
      coverage: "{{value}}% coverage"
    }
  },
  fr: {
    resultsComponents: {
      candidateResults: "Résultats des candidats",
      noCandidates: "Aucune donnée de candidats disponible",
      resultsByParty: "Résultats par parti",
      resultsByRegion: "Résultats par région",
      region: "Région",
      stations: "Bureaux",
      votesCast: "Votes exprimés",
      turnout: "Participation",
      leadingParty: "Parti en tête",
      status: {
        verified: "vérifié", approved: "approuvé", certified: "certifié",
        pending: "en attente", submitted: "soumis", disputed: "contesté",
        rejected: "rejeté", correction_requested: "correction demandée"
      }
    },
    statCards: {
      pollingStations: "Bureaux de vote",
      votesCast: "Votes exprimés",
      validVotes: "Votes valides",
      rejectedVotes: "Votes rejetés",
      coverage: "{{value}}% de couverture"
    }
  }
};

export default collationComponents;
